export enum AutomationConditionType {
  CandidateHired = 'candidate_hired',
  CandidateHasTask = 'candidate_has_task',
  CandidateTasksCompleted = 'candidate_tasks_completed',
  CandidateOverdue = 'candidate_overdue',
  CandidateHasNote = 'candidate_has_note',
}

export type AutomationCondition = {
  type: AutomationConditionType | null;
  data: null;
};
